<template>
    <div v-wechat-title="title" class="padding10">
        <el-row type="flex" align="middle">
            <el-col :md="5" :xl="3">
                <item-input type="search" placeholder="关键字搜索" v-model="searchValue" @input="search()"></item-input>
            </el-col>
            <el-col :md="5" :xl="3">
                <item-input type="select" v-model="print_status" :options="print" placeholder="全部" clearable></item-input>
            </el-col>
            <el-col :md="5" :xl="3">
                <item-input type="select" v-model="drug_type" :options="needPrintDrugType" placeholder="用药类型" clearable></item-input>
            </el-col>
            <el-col :md="11" :xl="15" class="align-right">
                <span v-show="prescriptionByDiagnosis">
                    术前诊断：
                    <item-input style="width: 200px;" type="select" v-model="prescription_diagnosis" :options="plan_diseases" placeholder="术前诊断" clearable></item-input>
                </span>
                <el-button type="primary" size="mini" @click="SyncUseDrug">同步</el-button>
                <el-button type="primary" size="mini" v-if="this.cffsBtnName != '0'" @click="SendCheckedToHis">{{ this.cffsBtnName }}</el-button>
                <el-button type="primary" size="mini" @click="loadPrescriptions">刷新</el-button>
                <el-button type="primary" size="mini" @click="loadFactorInfo">代办人信息</el-button>
                <template v-if="isCanPreViewPrescription == '1'">
                    <!-- 只有一个选项的时候直接打印预览了，不用再下拉选择 -->
                    <el-button type="primary" v-if="needPrintDrugTypeYuLan.length==1" size="mini" @click="printDrugPreview(needPrintDrugTypeYuLan[0])">打印预览</el-button>
                    <el-dropdown @command="printDrugPreview" v-else>
                        <el-button type="primary" size="mini">打印预览<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item v-for="drugType in needPrintDrugTypeYuLan" :key="drugType.value" v-text="drugType.label" :command="drugType"></el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
                <template v-else>
                <el-button type="primary" size="mini" v-if="needPrintDrugType.length==1" @click="printDrug(needPrintDrugType[0])">打印</el-button>
                <el-dropdown @command="printDrug" v-else>
                    <el-button type="primary" size="mini">打印<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-for="drugType in needPrintDrugType" :key="drugType.value" v-text="drugType.label" :command="drugType"></el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                </template>
                <el-button type="primary" size="mini" @click="saveDrug">保存</el-button>
                <el-popover placement="bottom" :open-delay="600">
                    <el-button size="mini" plain slot="reference">
                        <font-awesome-icon :icon="['fas', 'cog']"></font-awesome-icon>
                        <span class="hidden-md-and-down">&nbsp;列配置</span>
                    </el-button>
                    <el-scrollbar wrap-class="scrollbar-wrapper-y" style="height: 250px; width: max-content">
                        <div class="config-column">
                            <item-input type="checkboxgroup" :options="configColumns" v-model="user_config_columns"></item-input>
                        </div>
                    </el-scrollbar>

                    <el-divider></el-divider>
                    <div style="text-align: right">
                        <el-link type="primary" size="mini" class="margin-right10" @click="SaveUserColumns">保存</el-link>
                    </div>
                </el-popover>
            </el-col>
        </el-row>
        <list-view
            :showSequence="true"
            :selection="true"
            ref="sprescription-list"
            class="sprescriptionlist"
            :datalist="datalist"
            :tableHeight="this.screenHeight - 186"
            @extrabutton-click="ExtraButtonClick"
            @changeColWidth="changeColWidth"
            :columns="userListColumn"
            :buttons="[]"
            :reserveSelection="false"
        >
            <template slot="send_state" slot-scope="{ row }">
                <p :title="titleLabel(row)" :style="getstateStyle(row)">
                    {{ row.send_state }}
                </p>
            </template>
        </list-view>
        <form-dialog title="代办人信息" :visible.sync="factorView.dialogFormVisible" :data="factorView.data" :columns="factorViewColumns" width="45%" @confirm="deliver"> </form-dialog>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Sortable from 'sortablejs'
export default {
    name: `Prescription`,
    data() {
        return {
            title: `处方单`,
            enable_tagsview: false,
            datalist: [],
            all_data_list: [],
            drug_type: undefined,
            searchValue: undefined,
            print_status: undefined,
            tableName: `api_Nursing/Prescription`,
            user_config_columns: [],
            configColumns: [],
            ischecked: false,
            prescriptionDbrstr: this.$root.PrescriptionDbrList,
            prescriptionAgentInputMethod: this.$root.PrescriptionAgentInputMethod,
            dic_operating_ward_id: null,
            prescriptionDbrObjs: null,
            defaultdbr: {},
            print: [
                {
                    value: `已打印`,
                    label: `已打印`
                },
                {
                    value: `未打印`,
                    label: `未打印`
                }
            ],
            invalidPrescriptionConfig: this.$root.InvalidPrescriptionConfig,
            prescription_status: [
                { value: 0, label: `` },
                { value: -1, label: `已作废` }
            ],
            token: this.$route.query.token,
            changedDrugs: [],
            factorView: {
                // 代办人信息
                dialogFormVisible: false,
                data: {}
            },
            cffsBtnName: this.$root.CFFSBtnName,
            isCanEditPrescription: this.$root.IsCanEditPrescription,
            isCanPreViewPrescription: this.$root.IsCanPreViewPrescription,
            isWorkerByDuty: this.$root.IsWorkerByDuty,
            requiredFunctions: this.$root.validateRequiredFunctions ? this.$root.validateRequiredFunctions.split(`,`) : [],
            requiredFields: [],
            prescriptionValidateConfig: this.$root.PrescriptionValidateConfig,
            batchNoSelect: this.$root.BatchNoSelect && this.$root.BatchNoSelect == `1`,
            prescriptionValidateConfigObj: {},
            decimalNumber: this.$root.DecimalNumber && parseInt(this.$root.DecimalNumber) || 2,
            prescriptionByDiagnosis: this.$root.PrescriptionByDiagnosis && this.$root.PrescriptionByDiagnosis == `1`,
            prescription_diagnosis: null,
            plan_diseases: [],
            agentRelationshipConfig: (this.$root.PrescriptionAgentRelationshipConfig && this.$root.PrescriptionAgentRelationshipConfig != `0`) ? this.$root.PrescriptionAgentRelationshipConfig.split(`|`) : []
        }
    },
    created() {
        if (this.token) {
            sessionStorage.setItem(`token`, this.token)
            this.$store.dispatch(`ADD_CURRENTUSER`)
        }

        this.$store.dispatch(`enums/ADD_ALL_ENUM`)
        this.$store.dispatch(`ADD_WARD_AUTH`)
        this.$store.dispatch(`drug/ADD_DRUG_TYPE`)
        this.$store.dispatch(`drug/ADD_DRUG_UNIT`)
        this.$store.dispatch(`drug/ADD_DRUG_WAY`)
        this.$store.dispatch(`sysuser/ADD_WORKERS`)
        this.$nextTick(() => {
            this.getPlanDiseases().then(() => {
                this.loadPrescriptionDiagnosis().then(() => {
                    this.loadPrescriptions()
                    this.loadRequiredColumns()
                })
            })
        })
        if (this.active_ward && this.active_ward.origion > 0) {
            this.dic_operating_ward_id = this.active_ward && this.active_ward.origion
            console.log(this.active_ward)
            if (this.prescriptionDbrstr != `` && this.prescriptionDbrstr != undefined) {
                let t = eval(
                    `(` + this.prescriptionDbrstr + `)`
                )
                this.prescriptionDbrObjs = _.filter(t, d => {
                    return !d.operating_ward_id || d.operating_ward_id == 0 || d.operating_ward_id == this.dic_operating_ward_id
                })

                let dbr = this.prescriptionDbrObjs.find(s => s.isdefault == `1`)
                let age = this.validateAndCaluAge(dbr.dbridentity)
                this.defaultdbr = dbr
                if (age > 0) {
                    this.$set(this.defaultdbr, `dbrage`, age)
                }
            }
        } else {
            this.$store.dispatch(`localip/LOAD_LOCAL_IP`).then(data => {
                this.loadWorkStation()
            })
        }
        if (this.prescriptionValidateConfig && this.prescriptionValidateConfig != ``) {
            let ls = eval(`(` + this.prescriptionValidateConfig + `)`)
            this.prescriptionValidateConfigObj = ls
        }
        console.log(this.prescriptionValidateConfigObj)
    },
    computed: {
        ...mapGetters([`sys_enums`, `localip/ipAddress`, `active_ward`, `drug/drug_type`, `drug/drug_unit`, `drug/drug_way`, `currentUser`, `screenHeight`, `sysuser/workers_by_duty`, `sysuser/workers_by_dutyNew`]),
        tableHeight() {
            return (this.screenHeight && this.screenHeight - 300) || 0
        },
        surgeryId() {
            return this.$route.query.surgery_id
        },
        allDrugType() {
            return this[`drug/drug_type`]
        },
        worker() {
            if (this.isWorkerByDuty == `0`) {
                return this[`sysuser/workers_by_duty`]
            } else if (this.isWorkerByDuty == `1`) {
                return this[`sysuser/workers_by_dutyNew`]
            }
        },
        userListColumn() {
            let that = this
            if (this.configColumns.length == 0) {
                return this.columnList
            } else if (this.user_config_columns.length == 0) {
                // added by xiaorui,默认如果用户没有配置任何列 则 1.列配置勾选上当前页面所有列 2.展示当前列表上所有列
                that.user_config_columns = that.configColumns.map(c => c.value)
                return this.columnList
            }
            let allcolumn = _.filter(this.columnList, c => {
                return _.includes(this.user_config_columns, c.prop) || c.isExpand || c.isKey || (c.isDisplayOrder && c.isListable)
            })
            // debugger
            allcolumn.map(d => {
                // debugger
                let f = that.user_config_columns2.find(s => s.col_name == d.prop)
                if (f && f.col_width > 0) {
                    d.width = f.col_width
                }
            })
            let r = _.orderBy(allcolumn, function(ac) {
                let i = _.findIndex(that.configColumns, { value: ac.prop })
                return i
            })
            return r
        },
        columnList() {
            let me = this
            return [
                {
                    type: `string`,
                    prop: `___index`,
                    label: `unique`,
                    isKey: true
                },
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    isKey: true
                },
                {
                    type: `remoteselect`,
                    prop: `dic_drug_id`,
                    label: `药品全称`,
                    width: `300`,
                    isListable: true,
                    options: `/api/AcisSystem/Drug//SearchPrescriptionDrugFidlerHospitalWard?surgeryid=${this.surgeryId}`,
                    change: (that, { row, index }) => {
                        if (row.dic_drug_id && row.dic_drug_id.value) {
                            let req = this.myaxios.get(`/api/AcisSystem/Drug/Get/${row.dic_drug_id.value}`)
                            if (index + 1 == this.datalist.length) {
                                this.datalist.push({ ___index: _.now(), exists_black: 1 })
                            }
                            req.then(data => {
                                let types = _.filter(this[`drug/drug_type`], d => {
                                    return data.drug_types && data.drug_types.indexOf(d.value) > -1
                                })
                                let type = types && (_.find(types, { IsPrescription: true }) || types[0])
                                this.$set(row, `spec`, data.spec)
                                this.$set(row, `unit`, data.drug_unit)
                                this.$set(row, `amount`, 1)
                                this.$set(row, `total_dose`, data.dose)
                                this.$set(row, `add_drug_way`, data.add_drug_way)
                                this.$set(row, `dic_drug_type_id`, type && type.value)
                                if (me.batchNoSelect) {
                                    let batchnoarr = data && data.batch_no && data.batch_no.split(`,`).map(p => {
                                        return {
                                            value: p,
                                            label: p
                                        }
                                    }) || []
                                    this.$set(row, `batchno_arr`, batchnoarr)
                                    if (batchnoarr.length >= 1) {
                                        this.$set(row, `batch_no`, batchnoarr[0].value)
                                    } else {
                                        this.$set(row, `batch_no`, ``)
                                    }
                                } else {
                                    this.$set(row, `batch_no`, data.batch_no)
                                }
                            })
                        } else {
                            this.$set(row, `spec`, ``)
                            this.$set(row, `unit`, ``)
                            this.$set(row, `amount`, ``)
                            this.$set(row, `add_drug_way`, ``)
                            this.$set(row, `dic_drug_type_id`, ``)
                            this.$set(row, `batch_no`, ``)
                            this.$set(row, `batchno_arr`, [])
                            this.$set(row, `enum_useTo`, 1)
                        }
                        if (this.sys_enums.Enum_UseTo && this.sys_enums.Enum_UseTo.length > 0 && this.sys_enums.Enum_UseTo[0].value) {
                            this.$set(row, `enum_useTo`, this.sys_enums.Enum_UseTo[0].value)
                        }
                    },
                    readonly: (that, { row }) => {
                        return (!!(this.isCanEditPrescription && (this.isCanEditPrescription == `0` || this.isCanEditPrescription == `2`))) || (row.enum_send_state && (row.enum_send_state == 1 || row.enum_send_state == 2)) || (row.print_time && me.invalidPrescriptionConfig == `1`)
                    }
                },
                {
                    type: `string`,
                    prop: `spec`,
                    label: `规格`,
                    isListable: true
                },
                {
                    type: `integer`,
                    prop: `amount`,
                    label: `数量`,
                    isListable: true,
                    queryable: true,
                    isCreatable: true,
                    isEditable: true,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    readonly: (that, { row }) => {
                        return (!!(this.isCanEditPrescription && this.isCanEditPrescription == `0`)) || (row.enum_send_state && (row.enum_send_state == 1 || row.enum_send_state == 2)) || (row.print_time && me.invalidPrescriptionConfig == `1`)
                    }
                },
                {
                    type: `float`,
                    prop: `total_dose`,
                    label: `实际用量`,
                    width: `100`,
                    isListable: true,
                    isCreatable: true,
                    isEditable: true,
                    decimal_places: this.decimalNumber,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    readonly: (that, { row }) => {
                        return (!!(this.isCanEditPrescription && this.isCanEditPrescription == `0`)) || (row.enum_send_state && (row.enum_send_state == 1 || row.enum_send_state == 2)) || (row.print_time && me.invalidPrescriptionConfig == `1`)
                    }
                },
                {
                    type: `string`,
                    prop: `surplus_dose`,
                    label: `剩余量`,
                    isListable: true
                },
                {
                    type: `select`,
                    prop: `unit`,
                    label: `单位`,
                    width: `60`,
                    isListable: true,
                    isCreatable: true,
                    isEditable: true,
                    options: _.map(this[`drug/drug_unit`], d => {
                        return {
                            value: d.label,
                            label: d.label
                        }
                    }),
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    readonly: (that, { row }) => {
                        return (!!(this.isCanEditPrescription && this.isCanEditPrescription == `0`)) || (row.enum_send_state && (row.enum_send_state == 1 || row.enum_send_state == 2)) || (row.print_time && me.invalidPrescriptionConfig == `1`)
                    }
                },
                {
                    type: `select`,
                    prop: `add_drug_way`,
                    label: `给药途径`,
                    isListable: true,
                    isCreatable: true,
                    isEditable: true,
                    options: _.map(this[`drug/drug_way`], d => {
                        return {
                            value: d.label,
                            label: d.label
                        }
                    }),
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    readonly: (that, { row }) => {
                        return (!!(this.isCanEditPrescription && this.isCanEditPrescription == `0`)) || (row.enum_send_state && (row.enum_send_state == 1 || row.enum_send_state == 2)) || (row.print_time && me.invalidPrescriptionConfig == `1`)
                    }
                },
                {
                    type: `string`,
                    prop: `batch_no`,
                    label: `批号`,
                    isListable: !me.batchNoSelect,
                    isCreatable: !me.batchNoSelect,
                    isEditable: !me.batchNoSelect,
                    readonly: (that, { row }) => {
                        return (!!(this.isCanEditPrescription && this.isCanEditPrescription == `0`)) || (row.enum_send_state && (row.enum_send_state == 1 || row.enum_send_state == 2)) || (row.print_time && me.invalidPrescriptionConfig == `1`)
                    }
                },
                {
                    type: `select`,
                    prop: `batch_no`,
                    label: `批号`,
                    isListable: me.batchNoSelect,
                    isCreatable: me.batchNoSelect,
                    isEditable: me.batchNoSelect,
                    allowCreate: true,
                    options: (that, { row }) => {
                        return row.batchno_arr
                    },
                    readonly: (that, { row }) => {
                        return (!!(this.isCanEditPrescription && this.isCanEditPrescription == `0`)) || (row.enum_send_state && (row.enum_send_state == 1 || row.enum_send_state == 2)) || (row.print_time && me.invalidPrescriptionConfig == `1`)
                    }
                },
                {
                    type: `datetime`,
                    prop: `disposal_time`,
                    label: `弃药时间`,
                    width: `160 `,
                    isListable: true,
                    isCreatable: true,
                    isEditable: true,
                    readonly: (that, { row }) => {
                        return (!!(this.isCanEditPrescription && this.isCanEditPrescription == `0`)) || (row.enum_send_state && (row.enum_send_state == 1 || row.enum_send_state == 2)) || (row.print_time && me.invalidPrescriptionConfig == `1`)
                    }
                },
                {
                    type: `string`,
                    prop: `disposal_location`,
                    label: `弃药地点`,
                    width: `150 `,
                    isListable: true,
                    isCreatable: true,
                    isEditable: true,
                    readonly: (that, { row }) => {
                        return (!!(this.isCanEditPrescription && this.isCanEditPrescription == `0`)) || (row.enum_send_state && (row.enum_send_state == 1 || row.enum_send_state == 2)) || (row.print_time && me.invalidPrescriptionConfig == `1`)
                    }
                },
                {
                    type: `remotemultiselect`,
                    prop: `verifierobj`,
                    label: `核对者`,
                    width: `140`,
                    isListable: true,
                    isCreatable: true,
                    isEditable: true,
                    readonly: (that, { row }) => {
                        return (!!(this.isCanEditPrescription && this.isCanEditPrescription == `0`)) || (row.enum_send_state && (row.enum_send_state == 1 || row.enum_send_state == 2)) || (row.print_time && me.invalidPrescriptionConfig == `1`)
                    },
                    showCol: true,
                    options: (that, { row }) => {
                        return q => {
                            let works = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`麻醉医生`] || []
                            let deepworkers = JSON.parse(JSON.stringify(works))
                            let hsworkers = this.isWorkerByDuty == `0` ? this.worker[`护士`] || [] : this.worker[`巡回护士`] || []
                            hsworkers.forEach((item, index) => {
                                let mc = _.find(deepworkers, x => x.value == item.value)
                                if (mc) {
                                } else {
                                    deepworkers.push(item)
                                }
                            })

                            if (q && q.keyword) {
                                return deepworkers.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return deepworkers
                            }
                        }
                    },
                    colspan: 6,
                    config: {
                        collapseTags: true
                    }
                },
                {
                    type: `month`,
                    prop: `effective_date`,
                    label: `有效日期`,
                    width: `150 `,
                    config: {
                        datetimeFormate: `yyyy/MM`,
                        noPadding: true,
                        editable: true
                    },
                    isListable: true,
                    isCreatable: true,
                    isEditable: true,
                    readonly: (that, { row }) => {
                        return (!!(this.isCanEditPrescription && this.isCanEditPrescription == `0`)) || (row.enum_send_state && (row.enum_send_state == 1 || row.enum_send_state == 2)) || (row.print_time && me.invalidPrescriptionConfig == `1`)
                    }
                },
                {
                    type: `select`,
                    prop: `dic_drug_type_id`,
                    label: `药品类型`,
                    isListable: true,
                    isCreatable: true,
                    isEditable: true,
                    options: this.needPrintDrugType,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    readonly: (that, { row }) => {
                        return (!!(this.isCanEditPrescription && this.isCanEditPrescription == `0`)) || (row.enum_send_state && (row.enum_send_state == 1 || row.enum_send_state == 2)) || (row.print_time && me.invalidPrescriptionConfig == `1`)
                    }
                },
                {
                    type: `string`,
                    prop: `prescription_no`,
                    label: `处方单号`,
                    isListable: true
                },
                {
                    type: `remoteselect`,
                    prop: `anes_doctor`,
                    label: `麻醉医生`,
                    width: `140`,
                    isListable: true,
                    readonly: (that, { row }) => {
                        return (row.enum_send_state && (row.enum_send_state == 1 || row.enum_send_state == 2)) || (row.print_time && me.invalidPrescriptionConfig == `1`)
                    },
                    options: (that, { row }) => {
                        return q => {
                            let works = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`麻醉医生`] || []
                            if (this.$root.UseASACheck == `1`) {
                                works = works.map(d => {
                                    return {
                                        label: d.label,
                                        value: d.value,
                                        jianpin: d.jianpin,
                                        card_no: d.card_no,
                                        worker_duty: d.worker_duty,
                                        code: d.asa == null ? `--/${d.code}` : d.asa + `/` + d.code
                                    }
                                })
                            }

                            if (q && q.keyword) {
                                return works.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return works
                            }
                        }
                    }
                },
                {
                    type: `string`,
                    prop: `print_status`,
                    label: `打印情况`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `print_person`,
                    label: `打印人`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `print_time`,
                    label: `打印时间`,
                    isListable: true
                },
                {
                    type: `select`,
                    prop: `enum_useTo`,
                    label: `用途`,
                    isListable: true,
                    options: this.sys_enums.Enum_UseTo || [],
                    default: this.sys_enums.Enum_UseTo && this.sys_enums.Enum_UseTo.length > 0 && this.sys_enums.Enum_UseTo[0].value || null,
                    readonly: (that, { row }) => {
                        return (!!(this.isCanEditPrescription && this.isCanEditPrescription == `0`)) || (row.enum_send_state && (row.enum_send_state == 1 || row.enum_send_state == 2)) || (row.print_time && me.invalidPrescriptionConfig == `1`)
                    }
                },
                {
                    type: `string`,
                    prop: `remark`,
                    label: `备注`,
                    isListable: true,
                    isCreatable: true,
                    isEditable: true,
                    readonly: (that, { row }) => {
                        return (row.enum_send_state && (row.enum_send_state == 1 || row.enum_send_state == 2)) || (row.print_time && me.invalidPrescriptionConfig == `1`)
                    }
                },
                {
                    type: `string`,
                    prop: `drugallergy`,
                    label: `药物过敏试验`,
                    isListable: true,
                    isCreatable: true,
                    isEditable: true,
                    readonly: (that, { row }) => {
                        return (row.enum_send_state && (row.enum_send_state == 1 || row.enum_send_state == 2)) || (row.print_time && me.invalidPrescriptionConfig == `1`)
                    }
                },
                {
                    type: `select`,
                    prop: `status`,
                    label: `单据状态`,
                    isListable: me.invalidPrescriptionConfig == `1`,
                    options: this.prescription_status || []
                },
                {
                    type: `string`,
                    prop: `modify_date`,
                    label: `作废时间`,
                    isListable: me.invalidPrescriptionConfig == `1`
                },
                {
                    type: `custom`,
                    prop: `send_state`,
                    label: `发送状态`,
                    isListable: true,
                    fixed: `right`
                },
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    label: `操作`,
                    isListable: true,
                    readonly: (that, { row }) => {
                        return (!!(this.isCanEditPrescription && this.isCanEditPrescription == `0`) || (row.enum_send_state && (row.enum_send_state == 1 || row.enum_send_state == 2)))
                    },
                    fixed: `right`,
                    options: function(that, { row }) {
                        if (!row.dic_drug_id || (row.enum_send_state && (row.enum_send_state == 1 || row.enum_send_state == 2)) || (row.status == -1 && me.invalidPrescriptionConfig == `1`)) {
                            return []
                        } else {
                            if (row.print_time && me.invalidPrescriptionConfig == `1`) {
                                return [{
                                    class: `is-plain`,
                                    label: `作废`,
                                    icon: ``,
                                    type: `danger`,
                                    emit: `invalidPrescription`,
                                    permission: `default`
                                }]
                            } else {
                                return [{
                                    class: `is-plain`,
                                    label: `删除`,
                                    icon: ``,
                                    type: `danger`,
                                    emit: `deleteDrug`,
                                    permission: `default`
                                }]
                            }
                        }
                    }
                }
            ]
        },
        factorViewColumns() {
            let me = this
            let idCardValidate = (rule, value, callback) => {
                // 示例正则表达式：这里以中国的18位身份证号码为例
                const idCardPattern = /^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dXx]$/
                if (!value) {
                    callback(new Error(`请输入证件号码`))
                } else if (!idCardPattern.test(value)) {
                    callback(new Error(`证件号码格式不正确`))
                } else {
                    callback()
                }
            }
            let col = []
            if (this.prescriptionAgentInputMethod == `1`) {
                col.push({
                    type: `string`,
                    prop: `dbrname`,
                    label: `姓名`,
                    colspan: 12,
                    validate: [{ required: true, message: `必填项目`, trigger: `change` }]
                })
            } else {
                col.push(
                    {
                        type: `select`,
                        prop: `dbrname`,
                        label: `姓名`,
                        colspan: 12,
                        config: {
                            allowCreate: true
                        },
                        options: () => {
                            return _.map(this.prescriptionDbrObjs, d => {
                                return {
                                    value: d.dbrname,
                                    label: d.dbrname,
                                    jianpin: d.dbrname
                                }
                            })
                        },
                        change: (that, { row, index }) => {
                            console.log(this.prescriptionDbrObjs)
                            if (this.prescriptionDbrObjs != null) {
                                let r = this.prescriptionDbrObjs && this.prescriptionDbrObjs.find(s => s.dbrname == row.dbrname)
                                if (r) {
                                    this.$set(row, `dbrgx`, r.dbrgx)
                                    this.$set(row, `dbrname`, r.dbrname)
                                    this.$set(row, `dbrsex`, r.dbrsex)
                                    let age = this.validateAndCaluAge(r.dbridentity)
                                    if (age > 0) {
                                        this.$set(row, `dbrage`, age)
                                    } else {
                                        this.$set(row, `dbrage`, r.dbrage)
                                    }
                                    this.$set(row, `dbridentity`, r.dbridentity)
                                    this.$set(row, `dbrtelphone`, r.dbrtelphone)
                                } else {
                                    this.$set(row, `dbrgx`, ``)
                                    this.$set(row, `dbrsex`, ``)
                                    this.$set(row, `dbrage`, ``)
                                    this.$set(row, `dbridentity`, ``)
                                    this.$set(row, `dbrtelphone`, ``)
                                }
                            }
                        },
                        default: this.defaultdbr && this.defaultdbr.dbrname,
                        validate: [{ required: true, message: `必填项目`, trigger: `change` }]
                    })
            }
            if (this.agentRelationshipConfig && this.agentRelationshipConfig.length > 0) {
                col.push({
                    type: `select`,
                    prop: `dbrgx`,
                    label: `关系`,
                    colspan: 12,
                    options: () => {
                        return _.map(me.agentRelationshipConfig, d => {
                            return {
                                value: d,
                                label: d
                            }
                        })
                    },
                    validate: [{ required: true, message: `必填项目`, trigger: `change` }]
                })
            }
            return col.concat([
                {
                    type: `select`,
                    prop: `dbrsex`,
                    label: `性别`,
                    colspan: 12,
                    default: this.defaultdbr && this.defaultdbr.dbrsex,
                    options: () => {
                        return _.map(this.sys_enums.Enum_Sex, d => {
                            return {
                                value: d.value,
                                label: d.label,
                                jianpin: d.jianpin
                            }
                        })
                    }
                },
                {
                    type: `string`,
                    prop: `dbrage`,
                    label: `年龄`,
                    default: this.defaultdbr && this.defaultdbr.dbrage,
                    colspan: 12
                },
                {
                    type: `string`,
                    prop: `dbridentity`,
                    label: `身份证`,
                    default: this.defaultdbr && this.defaultdbr.dbridentity,
                    validate: [{ validator: idCardValidate, trigger: `blur` }, { required: true, message: `必填项目`, trigger: `blur` }],
                    colspan: 12,
                    change: (that, { row, index }) => {
                        let age = this.validateAndCaluAge(row.dbridentity)
                        if (age > 0) {
                            this.$set(row, `dbrage`, age)
                        }
                    }
                },
                {
                    type: `string`,
                    prop: `dbrtelphone`,
                    label: `手机号`,
                    default: this.defaultdbr && this.defaultdbr.dbrtelphone,
                    colspan: 12
                }
            ])
        },
        needPrintDrugType() {
            let drugTypes = _.filter(this[`drug/drug_type`], { IsPrescription: true })
            return drugTypes
        },
        needPrintDrugTypeYuLan() {
            let drugTypes = _.filter(this[`drug/drug_type`], { IsPrescription: true })
            return drugTypes
        }
    },
    mounted() {
        // 加载配置列
        this.loadConfigColumns()
        this.configColumnDrop()
    },
    methods: {
        // 获取术前诊断
        getPlanDiseases() {
            let that = this
            return new Promise((resolve, reject) => {
                that.plan_diseases = null
                if (!that.surgeryId) {
                    reject()
                } else {
                    if (that.prescriptionByDiagnosis) {
                        let req = this.myaxios.get(`/api/Nursing/Prescription/GetPlanDiseases?surgeryId=${that.surgeryId}`)
                        req.then(data => {
                            that.plan_diseases = data
                            resolve(data)
                        })
                            .catch(e => {
                                console.log(e)
                                resolve()
                            })
                    } else {
                        resolve()
                    }
                }
            })
        },
        validateAndCaluAge(idCard) {
            // 15位/18位身份证号
            let regExp = /(^[1-9]\d{7}(?:0\d|10|11|12)(?:0[1-9]|[1-2][\d]|30|31)\d{3}$)|(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)/
            let birthday, age
            if (regExp.test(idCard)) {
                if (idCard.length === 15) {
                    // 获取出生日期
                    let Y = idCard.substr(6, 1) == 0 ? `20` : `19`
                    birthday = Y + [idCard.substr(6, 2), idCard.substr(8, 2), idCard.substr(10, 2)].join(`-`)
                } else {
                    // 获取出生日期
                    birthday = [idCard.substr(6, 4), idCard.substr(10, 2), idCard.substr(12, 2)].join(`-`)
                }
                // 获取年龄
                age = this.getAgeByBirthday(birthday)
            } else {
                age = -1
            }
            return age
        },
        // 根据生日获取年龄
        getAgeByBirthday(val) {
            let currentYear = new Date().getFullYear() // 当前的年份
            let calculationYear = new Date(val).getFullYear() // 计算的年份
            const wholeTime = currentYear + val.substring(4) // 周岁时间
            const calculationAge = currentYear - calculationYear // 按照年份计算的年龄
            // 判断是否过了生日
            if (new Date().getTime() > new Date(wholeTime).getTime()) {
                return calculationAge
            } else {
                return calculationAge - 1
            }
        },
        loadWorkStation() {
            let that = this
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/AcisSystem/WorkstationConfig/Get?token=${that[`localip/ipAddress`]}`)
                req.then(data => {
                    if (data) {
                        let req1 = this.myaxios.get(`/api/AcisSystem/OperatingRoom/Get/${data.dic_operating_room_id || 0}`)
                        req1.then(d => {
                            this.dic_operating_ward_id = (d && d.dic_operating_ward_id) || data.dic_recovery_ward_id
                            console.log(this.dic_operating_ward_id)
                            if (this.prescriptionDbrstr != `` && this.prescriptionDbrstr != undefined) {
                                let t = eval(
                                    `(` + this.prescriptionDbrstr + `)`
                                )
                                this.prescriptionDbrObjs = _.filter(t, d => {
                                    return !d.operating_ward_id || d.operating_ward_id == 0 || d.operating_ward_id == this.dic_operating_ward_id
                                })
                                let dbr = this.prescriptionDbrObjs.find(s => s.isdefault == `1`)
                                let age = this.validateAndCaluAge(dbr.dbridentity)
                                this.defaultdbr = dbr
                                if (age > 0) {
                                    this.$set(this.defaultdbr, `dbrage`, age)
                                }
                            }
                        }).catch(e => {
                            console.log(e)
                        })
                    }
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        titleLabel(row) {
            if (row) {
                let sendtime = (row.send_time && this.$moment(row.send_time).format(`YYYY/MM/DD HH:mm`)) || `--`
                let sender = row.sender || `--`
                let FailureReason = row.FailureReason || `--`
                if (row.enum_send_state === 3) {
                    return `发送时间:${sendtime}\r\n发送人:${sender}\r\n失败原因:${FailureReason}`
                } else {
                    return `发送时间:${sendtime}\r\n发送人:${sender}`
                }
            }
        },
        getstateStyle(row) {
            let statecolor = `dodgerblue`
            if (row) {
                switch (row.enum_send_state) {
                case 0:
                    statecolor = `dodgerblue`
                    break
                case 1:
                    statecolor = `orange`
                    break
                case 2:
                    statecolor = `forestgreen`
                    break
                case 3:
                    statecolor = `red`
                    break
                }
            }
            return {
                color: statecolor
            }
        },
        loadPrescriptions() {
            if (!this.surgeryId) return
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/Nursing/Prescription/Get?surgeryId=${this.surgeryId}`)
                req.then(data => {
                    data = _.map(data, d => {
                        return {
                            id: d.id,
                            dic_drug_id: d.drug.name,
                            spec: d.drug.spec,
                            amount: d.amount,
                            batch_no: d.batch_no,
                            batchno_arr: d.batchnostr && d.batchnostr.split(`,`).map(p => {
                                return {
                                    value: p,
                                    label: p
                                }
                            }) || [],
                            dic_drug_type_id: d.dic_drug_type_id,
                            prescription_no: d.prescription_no,
                            anes_doctor: d.anes_doctor,
                            total_dose: d.total_dose,
                            add_drug_way: d.add_drug_way,
                            unit: d.unit,
                            print_status: d.print_time == null ? `未打印` : `已打印`,
                            print_time: (d.print_time && this.$moment(d.print_time).format(`YYYY-MM-DD HH:mm:ss`)) || ``,
                            print_person: d.print_person,
                            surplus_dose: (d.amount * d.drug.dose - d.total_dose).toNewFixed(this.decimalNumber),
                            remark: d.remark,
                            effective_date: this.$moment(d.effective_date).format(`YYYY-MM`) || ``,
                            disposal_time: (d.disposal_time && this.$moment(d.disposal_time).format(`YYYY-MM-DD HH:mm:ss`)) || ``,
                            disposal_location: d.disposal_location,
                            verifier_ids: d.verifier_ids,
                            verifierobj: d.verifierobj,
                            drugallergy: d.DrugAllergy,
                            enum_send_state: d.enum_send_state,
                            send_state: d.send_state,
                            send_time: d.send_time,
                            sender: d.sender,
                            sender_no: d.sender_no,
                            failure_reason: d.failure_reason,
                            send_return_id: d.send_return_id,
                            status: d.status,
                            // creator: d.creator,
                            // create_date: (d.create_date && this.$moment(d.create_date).format(`YYYY-MM-DD HH:mm:ss`)) || ``,
                            // modifier: d.modifier,
                            modify_date: (d.status == -1 && ((d.modify_date && this.$moment(d.modify_date).format(`YYYY-MM-DD HH:mm:ss`)) || ``)) || ``,
                            class_name: d.status == -1 ? `cancelclass` : ``,
                            enum_useTo: d.enum_useTo
                        }
                    })
                    this.datalist = data
                    this.datalist.push({})
                    console.log(data)
                    this.all_data_list = this.datalist
                    resolve(this.datalist)
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        loadRequiredColumns() {
            let that = this
            let req = this.myaxios.get(`/api/Nursing/Prescription/GetPrescriptionRequiredColumns`)
            req.then(data => {
                let requiredColumnNames = data
                that.requiredFields = _.filter(that.columnList, c => {
                    return _.includes(requiredColumnNames, c.label)
                })
            }).catch(e => {
                console.log(e)
            })
        },
        loadWorker(q, row) {
            let r = {
                operatingWardId: 0,
                keyword: q && q.keyword
            }
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/AcisSystem/Worker/SearchForChargeNew`, r)
                req.then(data => {
                    resolve(data)
                })
            })
        },
        // 验证必填项
        isValidRequired(datalist, fields) {
            let that = this
            try {
                if (fields && fields.length > 0) {
                    datalist.forEach(d => {
                        fields.forEach(f => {
                            if (d[f.prop] == null || d[f.prop] == `` || d[f.prop] == undefined) {
                                this.$alert(`<strong>请录入${f.label}！</strong>`, `提示`, {
                                    dangerouslyUseHTMLString: true,
                                    type: `warning`
                                })
                                throw new Error(`EndIterative`)
                            } else if (f.type == `integer` || f.type == `float`) {
                                let val = parseFloat(d[f.prop])
                                if (val <= 0) {
                                    this.$alert(`<strong>录入的${f.label}必须大于0！</strong>`, `提示`, {
                                        dangerouslyUseHTMLString: true,
                                        type: `warning`
                                    })
                                    throw new Error(`EndIterative`)
                                }
                            }
                        })
                    })
                }
                // 目前仅支持不同类型药品批号校验
                if (that.prescriptionValidateConfigObj && that.prescriptionValidateConfigObj.length > 0) {
                    that.prescriptionValidateConfigObj.forEach(v => {
                        let nodata = _.filter(datalist, d => {
                            return d.dic_drug_type_id == v.drug_type_id
                        })
                        if (nodata && nodata.length > 0) {
                            nodata.forEach(t => {
                                if (_.includes(v.required_fields, `batch_no`)) {
                                    if (!t.batch_no || t.batch_no.trim() == ``) {
                                        that.$alert(`<strong>${v.drug_type}批号必填！</strong>`, `提示`, {
                                            dangerouslyUseHTMLString: true,
                                            type: `warning`
                                        })
                                        throw new Error(`EndIterative`)
                                    }
                                }
                            })
                        }
                    })
                }
            } catch (e) {
                if (e.message != `EndIterative`) throw e
                return e
            }
        },
        saveDrug() {
            let that = this
            let data = _.filter(that.datalist, d => {
                return d.dic_drug_id && !(d.status == -1 && that.invalidPrescriptionConfig == `1`)
            })

            // 根据配置检查当前功能是否需要必填验证
            if ((_.find(that.requiredFunctions, d => d == `保存`) && that.requiredFields.length > 0) ||
            (that.prescriptionValidateConfigObj && that.prescriptionValidateConfigObj.length > 0)) {
                // 必填项列验证不通过弹框提示后return返回
                if (that.isValidRequired(data, that.requiredFields)) {
                    return
                }
            }

            that.Save(data).then(() => {
                that.$message.success(`保存成功`)
                that.loadPrescriptions()
            })
        },
        // 单独抽取了一个保存方法
        Save(data) {
            let that = this
            return new Promise((resolve, reject) => {
                console.log(data)
                let updateData = _.filter(data, d => {
                    return d.id && d.id != undefined && d.enum_send_state != 1 && d.enum_send_state != 2
                }).map(d => {
                    return {
                        id: d.id,
                        add_drug_way: d.add_drug_way,
                        amount: d.amount,
                        batch_no: d.batch_no,
                        dic_drug_id: d.dic_drug_id.value || d.dic_drug_id,
                        dic_drug_type_id: d.dic_drug_type_id,
                        prescription_no: d.prescription_no,
                        anes_doctor: d.anes_doctor == `` ? null : d.anes_doctor && d.anes_doctor.value,
                        print_person: d.print_person,
                        print_status: d.print_status,
                        print_time: d.print_time,
                        spec: d.spec,
                        total_dose: d.total_dose,
                        unit: d.unit,
                        remark: d.remark,
                        effective_date: d.effective_date,
                        disposal_time: (!d.disposal_time) ? `0001/1/1 0:00:00` : d.disposal_time,
                        disposal_location: d.disposal_location,
                        verifierobj: d.verifierobj,
                        verifier_ids: d.verifierobj && d.verifierobj.map(a => a && a.value).toString(),
                        DrugAllergy: d.drugallergy,
                        enum_send_state: d.enum_send_state,
                        send_state: d.send_state,
                        send_time: d.send_time,
                        sender: d.sender,
                        sender_no: d.sender_no,
                        failure_reason: d.failure_reason,
                        send_return_id: d.send_return_id,
                        enum_useTo: d.enum_useTo
                    }
                })
                let addData = _.filter(data, d => {
                    return !(d.id && d.id != undefined)
                }).map(d => {
                    return {
                        id: 0,
                        dic_drug_id: d.dic_drug_id.value,
                        dic_drug_type_id: d.dic_drug_type_id,
                        add_drug_way: d.add_drug_way,
                        unit: d.unit,
                        amount: d.amount,
                        anes_doctor: d.anes_doctor == `` ? null : d.anes_doctor && d.anes_doctor.value,
                        total_dose: d.total_dose,
                        biz_surgery_info_id: this.surgeryId,
                        batch_no: d.batch_no,
                        remark: d.remark,
                        effective_date: d.effective_date,
                        disposal_time: d.disposal_time,
                        disposal_location: d.disposal_location,
                        verifierobj: d.verifierobj,
                        verifier_ids: d.verifierobj && d.verifierobj.map(a => a && a.value).toString(),
                        DrugAllergy: d.drugallergy,
                        enum_send_state: d.enum_send_state,
                        send_state: d.send_state,
                        send_time: d.send_time,
                        sender: d.sender,
                        sender_no: d.sender_no,
                        failure_reason: d.failure_reason,
                        send_return_id: d.send_return_id,
                        enum_useTo: d.enum_useTo
                    }
                })
                let req = this.myaxios.post(`/api/Nursing/Prescription/PostMany`, addData)
                let req1 = this.myaxios.put(`/api/Nursing/Prescription/PutMany`, updateData)

                let reqdata = []
                reqdata.push({
                    label: `PrescriptionDiagnosis`,
                    value: that.prescription_diagnosis
                })
                let req2 = this.myaxios.put(`/api/Preoperative/Apply/PutExtraData/${this.surgeryId}`, reqdata)
                this.myaxios
                    .all(req, req1, req2)
                    .then(([data, data1, data2]) => {
                        this.myaxios.post(`/api/Nursing/Prescription/SaveAfter?surgeryId=${this.surgeryId}`).then(res => {
                            if (res && res != ``) {
                                this.$alert(res, `提醒`, {
                                    dangerouslyUseHTMLString: true,
                                    type: `warning`
                                })
                            }
                            resolve()
                        })
                    })
                    .catch(e => {
                        console.log(e)
                        reject(e)
                    })
            })
        },
        SendCheckedToHis() {
            let that = this
            if (that.changedDrugs.length == 0) {
                this.$message.warning(`请至少选择一项药品回传HIS`)
                return
            }

            let addData = _.filter(that.changedDrugs, d => {
                return !(d.id && d.id != undefined)
            })

            // 如果有未保存的数据，需要先保存后才能回传His
            if (addData && addData.length > 0) {
                this.$alert(`<strong>新增药品需要先保存才能回传His</strong>`, `提示`, {
                    dangerouslyUseHTMLString: true,
                    type: `warning`
                })
                return
            }

            let stateError = _.filter(that.changedDrugs, d => {
                return (d.enum_send_state && (d.enum_send_state == 1 || d.enum_send_state == 2)) && !(d.status == -1 && that.invalidPrescriptionConfig == `1`)
            })

            // 只有未发送或发送失败的才能回传His
            if (stateError && stateError.length > 0) {
                this.$alert(`<strong>发送中，和发送成功的不允许发送，请重新选择未发送或发送失败的！</strong>`, `提示`, {
                    dangerouslyUseHTMLString: true,
                    type: `warning`
                })
                return
            }

            // 根据配置检查当前功能是否需要必填验证
            if ((_.find(that.requiredFunctions, d => d == `保存`) && that.requiredFields.length > 0) ||
            (that.prescriptionValidateConfigObj && that.prescriptionValidateConfigObj.length > 0)) {
                // 必填项列验证不通过弹框提示后return返回
                if (that.isValidRequired(that.changedDrugs, that.requiredFields)) {
                    return
                }
            }
            that.Save(that.changedDrugs).then(() => {
                let req = this.myaxios.post(
                    `/api/Nursing/Prescription/SendDrugToHis`,
                    _.map(that.changedDrugs, d => d.id)
                )
                req.then(() => {
                    this.$message.success(`已发送`)
                    this.loadPrescriptions()
                }).catch(() => {
                    this.loadPrescriptions()
                })
            })
        },
        invalidPrescription({ row, index }) {
            this.$confirm(`确定作废该处方?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`
            }).then(() => {
                if (!(row && row.id)) {
                    this.loadPrescriptions()
                    return
                }

                let checkreq = this.myaxios.get(`/api/Nursing/Prescription/BeforeInvalidPrescription?prescriptionId=${row.id}&surgeryId=${this.surgeryId}`)
                checkreq.then(data => {
                    if (data != ``) {
                        this.$message.error(`作废失败:${data}`)
                        return
                    }
                    let rowData = {
                        id: row.id,
                        status: -1,
                        anes_doctor: row.anes_doctor && row.anes_doctor.value
                    }
                    let req = this.myaxios.put(`/api/Nursing/Prescription/Put`, rowData)
                    req.then(data => {
                        this.loadPrescriptions()
                    }).catch(e => {
                        console.log(e)
                    })
                })
            })
        },
        deleteDrug({ row, index }) {
            this.$confirm(`此操作将永久删除该记录, 是否继续?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`
            }).then(() => {
                if (!(row && row.id)) {
                    this.datalist.splice(index, 1)
                    return
                }
                let req = this.myaxios.delete(`/api/Nursing/Prescription/Delete/${row && row.id}`)
                req.then(data => {
                    this.datalist.splice(index, 1)
                    // this.loadPrescriptions()
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        loadPrescriptionDiagnosis() {
            if (!this.surgeryId) return
            let that = this
            that.prescription_diagnosis = ``
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/Preoperative/Apply/GetExtraDatas/${this.surgeryId}`)
                req.then(data => {
                    console.log(`GetExtraDatas`, data)
                    if (data.length != 0) {
                        let r = _.find(data, { DataKey: `PrescriptionDiagnosis` })
                        if (r) {
                            that.prescription_diagnosis = r.DataValue
                        }
                        resolve(r)
                    } else {
                        resolve()
                    }
                }).catch(e => {
                    console.log(e)
                    resolve()
                })
            })
        },
        loadFactorInfo() {
            if (!this.surgeryId) return
            let req = this.myaxios.get(`/api/Preoperative/Apply/GetExtraDatas/${this.surgeryId}`)
            req.then(data => {
                let temp = {}
                if (data.length != 0) {
                    data.forEach(element => {
                        if (element.DataKey != `PrescriptionDiagnosis`) {
                            temp[`${element.DataKey}`] = element.DataValue
                        }
                    })
                }
                console.log(temp)
                this.factorView.data = temp
            }).catch(e => {
                console.log(e)
            })
            this.factorView.dialogFormVisible = true
        },
        SyncUseDrug() {
            let req = this.myaxios.get(`/api/Nursing/Prescription/SyncUseDrug?surgeryId=${this.surgeryId}`)
            req.then(data => {
                this.loadPrescriptions()
            }).catch(e => {
                console.log(e)
            })
        },
        ExtraButtonClick(target) {
            if (this[target.emit]) {
                this[target.emit](target)
            } else {
                this.$emit(target.emit, target)
            }
        },
        changeColWidth(nw, ow, col, evt) {
            let that = this
            // 列宽值改变则post列宽

            if (this.user_config_columns2.length == 0) {
                let uc = this.configColumns.map((c, index) => {
                    return {
                        col_name: c.value,
                        display_order: index,
                        enabled: _.includes(this.user_config_columns, c.value),
                        table_name: this.tableName
                    }
                })
                let req = this.myaxios.post(`/api/AcisSystem/SystemServer/SetColumnConfig`, uc)
                req.then(data => {
                    that.loadConfigColumns().then(d => {
                        that.changeColWidthBody(nw, ow, col, evt)
                    })
                }).catch(e => {})
            } else {
                that.changeColWidthBody(nw, ow, col, evt)
            }
        },
        changeColWidthBody(nw, ow, col, evt) {
            if (nw < 20) {
                nw = 20
            } else if (nw > 500) {
                nw = 500
            }
            let r = {
                col_name: col.property,
                col_width: parseInt(nw),
                table_name: this.tableName
            }
            let req = this.myaxios.post(`/api/AcisSystem/SystemServer/SetColumnWidth`, r)
            req.then(data => {
                this.$message.success(`列宽调整成功`)
                // if (this.reload) {
                //     this.reload()
                // }
            }).catch(e => {})
        },
        search(event) {
            let list = []
            if (!this.searchValue) {
                this.datalist = this.all_data_list
            } else {
                this.all_data_list.map(d => {
                    if (d && d.dic_drug_id && d.dic_drug_id.indexOf(this.searchValue) != -1) {
                        list.push(d)
                    }
                })
                this.datalist = list
            }
        },
        SearchPrescrption() {
            if (!this.drug_type && !this.print_status) {
                this.datalist = this.all_data_list
            } else {
                let data = _.filter(this.all_data_list, d => {
                    return d.dic_drug_type_id == this.drug_type || d.print_status == this.print_status
                })
                this.datalist = data
            }
        },
        selectionChange({ row }) {
            let that = this
            this.changedDrugs = _.filter(row, drug => {
                return drug.dic_drug_id && !(drug.status == -1 && that.invalidPrescriptionConfig == `1`)
            })

            this.ischecked = this.changedDrugs.length != 0
        },
        printDrug(drugType) {
            let that = this
            let drugTypeId = drugType.value
            let drugTypeName = drugType.label
            let printDrugs = _.filter(this.changedDrugs, { dic_drug_type_id: drugTypeId })
            let canceltext = that.invalidPrescriptionConfig == `1` ? `且未作废` : ``
            if (!this.ischecked || printDrugs.length == 0) {
                this.$message.warning(`请至少选择一项药品类型为“${drugTypeName}”${canceltext}的药品`)
                return
            }

            if (!drugType.PrescriptionDocKey) {
                this.$message.error(`请先配置“${drugTypeName}”处方的处方模板`)
                return
            }
            if (!drugType.PrescriptionNoGeneratorProc) {
                this.$message.error(`请先配置“${drugTypeName}”处方的处方单号生成存储过程`)
                return
            }

            let addData = _.filter(printDrugs, d => {
                return !(d.id && d.id != undefined)
            })

            // 如果有未保存的数据，需要先保存后才能打印
            if (addData && addData.length > 0) {
                this.$alert(`<strong>新增药品需要先保存才能打印</strong>`, `提示`, {
                    dangerouslyUseHTMLString: true,
                    type: `warning`
                })
                return
            }

            // 根据配置检查当前功能是否需要必填验证
            if ((_.find(that.requiredFunctions, d => d == `保存`) && that.requiredFields.length > 0) ||
            (that.prescriptionValidateConfigObj && that.prescriptionValidateConfigObj.length > 0)) {
                // 必填项列验证不通过弹框提示后return返回
                if (that.isValidRequired(that.changedDrugs, that.requiredFields)) {
                    return
                }
            }
            let data = _.filter(this.datalist, d => {
                return d.dic_drug_id && !(d.status == -1 && that.invalidPrescriptionConfig == `1`)
            })
            // ACIS-23813 文书及处方打印时默认保存一次
            this.Save(data).then(() => {
                let docId = this.$root.DOCUMENT[drugType.PrescriptionDocKey]
                let updateData = _.map(printDrugs, drug => {
                    return {
                        id: drug.id,
                        biz_surgery_info_id: this.surgeryId,
                        print_person: this.currentUser && this.currentUser.dic_worker_name,
                        print_time: this.$moment().format(`YYYY-MM-DD HH:mm:ss`),
                        prescription_no: drug.prescription_no,
                        DrugAllergy: drug.drugallergy,
                        anes_doctor: drug.anes_doctor == `` ? null : drug.anes_doctor && drug.anes_doctor.value,
                        enum_send_state: drug.enum_send_state,
                        send_state: drug.send_state,
                        send_time: drug.send_time,
                        sender: drug.sender,
                        sender_no: drug.sender_no,
                        failure_reason: drug.failure_reason,
                        send_return_id: drug.send_return_id,
                        enum_useTo: drug.enum_useTo
                    }
                })

                // 更新处方单号后打印
                let req = this.myaxios.put(`/api/Nursing/Prescription/UpdatePrescriptionNo`, updateData)
                req.then((d) => {
                    let urlcode = encodeURIComponent(`id=` + this.surgeryId)
                    console.log(urlcode)
                    let req = this.myaxios.post(`/api/Anonymous/Carte/RunCarteServer?type=carte_printPrescription&paramStr=` + urlcode)
                    req.then(data => {
                        let reqGetPrintName = this.myaxios.get(`/api/AcisSystem/DocConfig/GetByCode?code=${drugType.PrescriptionDocKey}`)
                        let req2 = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=isShowSendPrintMessage`)
                        this.myaxios
                            .all(reqGetPrintName, req2)
                            .then(([data, isShow]) => {
                                // 增加判断，如果配置区域打印机且为当前区域则按区域打印机进行赋值
                                let printerName = data && data.default_printer_name
                                if (that.active_ward && that.active_ward.value && data && data.default_printer_name_by_ward) {
                                    console.log(that.active_ward.value, data.default_printer_name_by_ward)
                                    let wardPrinterNames = eval(
                                        `(` + data.default_printer_name_by_ward + `)`
                                    )
                                    var wardRow = _.find(wardPrinterNames, x => x.ward == that.active_ward.value)
                                    if (wardRow && wardRow.printer_name) {
                                        printerName = wardRow && wardRow.printer_name
                                    }
                                }

                                if (printerName) {
                                    this.$store.dispatch(`PRINT_PDF_MehealthAgreement`, {
                                        host: this.$root.DOCSERVICE_BASE,
                                        params: Object.assign(
                                            {
                                                docid: docId,
                                                id1: this.surgeryId,
                                                objId: printDrugs.map(d => d.id).toString(),
                                                default_printer_name: data && data.default_printer_name
                                            },
                                            { isShowSendPrintMessage: isShow.value }
                                        )
                                    })
                                } else {
                                    this.$store.dispatch(`PRINT_PDF`, {
                                        host: this.$root.DOCSERVICE_BASE,
                                        params: Object.assign(
                                            {
                                                docid: docId,
                                                id1: this.surgeryId,
                                                objId: printDrugs.map(d => d.id).toString()
                                            },
                                            { isShowSendPrintMessage: isShow.value }
                                        )
                                    })
                                }

                                this.loadPrescriptions()
                            })
                            .catch(e => {
                                console.log(e)
                            })
                    }).catch(e => {
                        console.log(e)
                    })
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        printDrugPreview(drugType) {
            let that = this
            let drugTypeId = drugType.value
            let drugTypeName = drugType.label

            let printDrugs = _.filter(this.changedDrugs, { dic_drug_type_id: drugTypeId })
            if (!this.ischecked || printDrugs.length == 0) {
                this.$message.warning(`请至少选择一项药品类型为“${drugTypeName}”的药品`)
                return
            }
            if (!drugType.PrescriptionDocKey) {
                this.$message.error(`请先配置“${drugTypeName}”处方的处方模板`)
                return
            }
            if (!drugType.PrescriptionNoGeneratorProc) {
                this.$message.error(`请先配置“${drugTypeName}”处方的处方单号生成存储过程`)
                return
            }

            let addData = _.filter(printDrugs, d => {
                return !(d.id && d.id != undefined)
            })
            // 如果有未保存的数据，需要先保存后才能打印
            if (addData && addData.length > 0) {
                this.$alert(`<strong>新增药品需要先保存才能打印</strong>`, `提示`, {
                    dangerouslyUseHTMLString: true,
                    type: `warning`
                })
                return
            }

            // 根据配置检查当前功能是否需要必填验证
            if ((_.find(that.requiredFunctions, d => d == `保存`) && that.requiredFields.length > 0) ||
            (that.prescriptionValidateConfigObj && that.prescriptionValidateConfigObj.length > 0)) {
                // 必填项列验证不通过弹框提示后return返回
                if (that.isValidRequired(that.changedDrugs, that.requiredFields)) {
                    return
                }
            }
            let data = _.filter(this.datalist, d => {
                return d.dic_drug_id && !(d.status == -1 && that.invalidPrescriptionConfig == `1`)
            })
            // ACIS-23813 文书及处方打印时默认保存一次
            this.Save(data).then(() => {
                let docId = this.$root.DOCUMENT[drugType.PrescriptionDocKey]
                let updateData = _.map(printDrugs, drug => {
                    return {
                        id: drug.id,
                        biz_surgery_info_id: this.surgeryId,
                        print_person: this.currentUser && this.currentUser.dic_worker_name,
                        print_time: this.$moment().format(`YYYY-MM-DD HH:mm:ss`),
                        prescription_no: drug.prescription_no,
                        DrugAllergy: drug.drugallergy,
                        anes_doctor: drug.anes_doctor == `` ? null : drug.anes_doctor && drug.anes_doctor.value,
                        enum_send_state: drug.enum_send_state,
                        send_state: drug.send_state,
                        send_time: drug.send_time,
                        sender: drug.sender,
                        sender_no: drug.sender_no,
                        failure_reason: drug.failure_reason,
                        send_return_id: drug.send_return_id,
                        enum_useTo: drug.enum_useTo
                    }
                })
                // 更新处方单号后打印
                let req = this.myaxios.put(`/api/Nursing/Prescription/UpdatePrescriptionNo`, updateData)
                let params = {}
                req.then(() => {
                    let urlcode = encodeURIComponent(`id=` + this.surgeryId)
                    console.log(urlcode)
                    let req = this.myaxios.post(`/api/Anonymous/Carte/RunCarteServer?type=carte_printPrescription&paramStr=` + urlcode)
                    req.then(data => {
                        let reqGetPrintName = this.myaxios.get(`/api/AcisSystem/DocConfig/GetByCode?code=${drugType.PrescriptionDocKey}`)
                        let req2 = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=isShowSendPrintMessage`)
                        this.myaxios
                            .all(reqGetPrintName, req2)
                            .then(([data, isShow]) => {
                                if (data) {
                                    this.axios
                                        .get(`${this.$root.DOCSERVICE_BASE}/doc3.ashx/fill`, {
                                            params: Object.assign(
                                                {
                                                    from: `202005100000`,
                                                    to: `202005100000`,
                                                    id3: 1,
                                                    docid: docId,
                                                    id1: this.surgeryId,
                                                    objId: printDrugs.map(d => d.id).toString(),
                                                    default_printer_name: data && data.default_printer_name
                                                },
                                                params
                                            )
                                        })
                                        .then(res => {
                                            if (res.Status == `SUCCESS`) {
                                            // 弹出窗体打开url地址
                                                window.open(res.TargetUrl, `_blank`)
                                                this.loadPrescriptions()
                                            } else {
                                                this.$message.error(`预览不成功`)
                                            }
                                        })
                                }
                            })
                    })
                        .catch(e => {
                            console.log(e)
                        })
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        deliver(data) {
            let reqdata = []
            for (let key in data) {
                let obj = {}
                if (data[key] !== undefined) {
                    obj = {
                        value: data[key],
                        label: key
                    }
                    reqdata.push(obj)
                }
            }
            let req = this.myaxios.put(`/api/Preoperative/Apply/PutExtraData/${this.surgeryId}`, reqdata)
            req.then(data => {
                this.factorView.dialogFormVisible = false
            }).catch(e => {
                console.log(e)
            })
        },
        loadConfigColumns() {
            let req = this.myaxios.get(`api/AcisSystem/SystemServer/GetColumnConfig?tableName=${this.tableName}`)
            req.then(data => {
                let lcs = _.orderBy(this.columnList, function(lc) {
                    return _.findIndex(data, { col_name: lc.prop })
                })
                this.configColumns = lcs.map(c => {
                    return { value: c.prop, label: c.label, isListable: c.isListable, col_width: c.col_width }
                }).filter(d => {
                    return d.label != `unique` && d.isListable
                })
                this.user_config_columns = (data && _.filter(data, { enabled: true }).map(d => d.col_name)) || []
                this.user_config_columns2 =
                        (data &&
                            _.filter(data, { enabled: true }).map(d => {
                                return {
                                    col_name: d.col_name,
                                    col_width: d.col_width
                                }
                            })) ||
                        []
            })
        },
        SaveUserColumns() {
            let uc = this.configColumns.map((c, index) => {
                return {
                    col_name: c.value,
                    display_order: index,
                    enabled: _.includes(this.user_config_columns, c.value),
                    table_name: this.tableName
                }
            })
            let req = this.myaxios.post(`/api/AcisSystem/SystemServer/SetColumnConfig`, uc)
            req.then(data => {
                this.$message.success(`保存成功`)
                if (this.reload) {
                    this.reload()
                }
            }).catch(e => {})
        },
        configColumnDrop() {
            // if (!this.columnConfig) return
            const tbody = document.querySelector(`.config-column .el-checkbox-group`)
            const _this = this
            Sortable.create(tbody, {
                group: { name: `config-columns`, push: false, put: false },
                animation: 180,
                fallbackOnBody: true,
                delay: 0,
                onUpdate({ newIndex, oldIndex }) {
                    // 交换排序
                    if (newIndex == oldIndex) return
                    // console.log({ newIndex, oldIndex })
                    const currRow = _this.configColumns.splice(oldIndex, 1)[0]
                    _this.configColumns.splice(newIndex, 0, currRow)
                }
            })
        }
    },
    watch: {
        surgeryId: function() {
            this.getPlanDiseases().then(() => {
                this.loadPrescriptionDiagnosis().then(() => {
                    this.loadPrescriptions()
                })
            })
        },
        drug_type: function() {
            this.SearchPrescrption()
        },
        print_status: function() {
            this.SearchPrescrption()
        },
        active_ward: function() {
            this.dic_operating_ward_id = this.active_ward && this.active_ward.origion
            if (this.prescriptionDbrstr != `` && this.prescriptionDbrstr != undefined) {
                let t = eval(
                    `(` + this.prescriptionDbrstr + `)`
                )
                this.prescriptionDbrObjs = _.filter(t, d => {
                    return !d.operating_ward_id || d.operating_ward_id == 0 || d.operating_ward_id == this.dic_operating_ward_id
                })
                let dbr = this.prescriptionDbrObjs.find(s => s.isdefault == `1`)
                let age = this.validateAndCaluAge(dbr.dbridentity)
                this.defaultdbr = dbr
                if (age > 0) {
                    this.$set(this.defaultdbr, `dbrage`, age)
                }
            }
        }
    }
}
</script>
<style lang="less">
.cancelclass {
    color: red;
    text-decoration: line-through red !important;
}
.cancelclass .ellipsis {
    color: red;
    text-decoration: line-through red !important;
}
</style>
<style lang="less" scoped>
.sprescriptionlist /deep/ .el-checkbox__inner{
    width: 18px !important;
    height: 18px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Surgery/Prescription/Index.vue